import type { ReactNode } from "react";

interface InfoItemProps {
  label: string;
  value: ReactNode;
}

export default function InfoItem({ label, value }: InfoItemProps) {
  let displayValue = value;

  if (value instanceof Date) {
    displayValue = value.toLocaleDateString();
  }

    const isEmpty =
    displayValue === null ||
    displayValue === undefined ||
    displayValue === "";

  return (
    <div>
      <span className="text-sm text-[#666] leading-none font-semibold">
        {label}
      </span>

      <div className="text-sm sm:text-lg font-bold">
        {isEmpty ? "Tiada" : displayValue}
      </div>
    </div>
  );
}